// extracted by mini-css-extract-plugin
export var entityChip = "_sg-0";
export var entityChipMissing = "_sg-1";